import { Vector3 as n } from "three";
import { isOnLine as r } from "../../utils/index19.js";
import { LineV3toLine3 as o } from "../index2.js";
function m(e, t) {
  e = o(e), t = o(t);
  const i = 1e-3, s = e.delta(new n()).normalize(), f = t.delta(new n()).normalize();
  return s.dot(f) < 1 - i ? !1 : !!(r(e.start, t.start, t.end) || r(e.end, t.start, t.end) || r(t.start, e.start, e.end));
}
export {
  m as doLinesOverlap
};
//# sourceMappingURL=index6.js.map
